function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { listInbox, markRead, markAllRead, iconFor, whenLabel, openItem } from "../functions/inbox";
import BellIcon from "./bell-icon";

/*
 * The bell's panel (PlunkDocs specs/CONTENT_HUB_REVIEW_DESK_2026-10-21.md, mockup G): the latest items, "needs you"
 * items first, one click opens what an item is about. "See all" goes to /Notifications.
 */
export function InboxRow({
  item,
  onOpen,
  showSource
}) {
  const [icon, tone] = iconFor(item);
  const count = Number(item.groupCount) > 1 ? item.groupCount : 0;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "nc-item" + (item.read ? "" : " unread"),
    onClick: () => onOpen(item)
  }, /*#__PURE__*/React.createElement("span", {
    className: "nc-ic " + tone,
    "aria-hidden": "true"
  }, icon === "notifications_none" ? /*#__PURE__*/React.createElement(BellIcon, {
    size: 17
  }) : /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, icon)), /*#__PURE__*/React.createElement("span", {
    className: "nc-tx"
  }, /*#__PURE__*/React.createElement("b", null, item.headline), item.content ? /*#__PURE__*/React.createElement("small", null, item.content) : null, count || showSource ? /*#__PURE__*/React.createElement("small", {
    className: "nc-meta"
  }, [showSource ? showSource(item) : null, count ? `${count} updates` : null].filter(Boolean).join(" · ")) : null), /*#__PURE__*/React.createElement("span", {
    className: "nc-tm"
  }, whenLabel(item.sentAt), item.read ? null : /*#__PURE__*/React.createElement("span", {
    className: "nc-dot",
    "aria-label": "unread"
  })));
}
export default class NotificationPanel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: null,
      tab: "all",
      error: false
    });
    _defineProperty(this, "load", async tab => {
      const t = tab || this.state.tab;
      this.setState({
        tab: t,
        error: false
      });
      try {
        const r = await listInbox({
          filter: t,
          limit: 12
        });
        if (this._alive) this.setState({
          items: r.items
        });
      } catch (e) {
        if (this._alive) this.setState({
          items: [],
          error: true
        });
      }
    });
    _defineProperty(this, "open", async item => {
      if (!item.read) {
        try {
          await markRead(item.id);
        } catch (e) {/* still open it */}
      }
      this.props.onClose();
      openItem(item, this.props.history);
    });
    _defineProperty(this, "readAll", async () => {
      try {
        await markAllRead();
        this.load();
      } catch (e) {/* keep */}
    });
  }
  componentDidMount() {
    this._alive = true;
    this.load();
    this._onKey = e => {
      if (e.key === "Escape") this.props.onClose();
    };
    window.addEventListener("keydown", this._onKey);
  }
  componentWillUnmount() {
    this._alive = false;
    window.removeEventListener("keydown", this._onKey);
  }
  render() {
    const {
      items,
      tab,
      error
    } = this.state;
    const unread = this.props.unread || 0;
    const action = (items || []).filter(i => i.priority === "action" && !i.doneAt && !i.read);
    const rest = (items || []).filter(i => !action.includes(i));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "nc-catch",
      onClick: this.props.onClose
    }), /*#__PURE__*/React.createElement("div", {
      className: "nc-panel",
      role: "dialog",
      "aria-label": "Notifications"
    }, /*#__PURE__*/React.createElement("div", {
      className: "nc-hd"
    }, /*#__PURE__*/React.createElement("b", null, "Notifications"), unread > 0 && /*#__PURE__*/React.createElement("span", {
      className: "nc-pill"
    }, unread, " new"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nc-link",
      disabled: !unread,
      onClick: this.readAll
    }, "Mark all read")), /*#__PURE__*/React.createElement("div", {
      className: "nc-tabs",
      role: "tablist"
    }, [["all", "All"], ["action", "Needs you"], ["unread", "Unread"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      role: "tab",
      "aria-selected": tab === k,
      className: tab === k ? "on" : "",
      onClick: () => this.load(k)
    }, l))), /*#__PURE__*/React.createElement("div", {
      className: "nc-body"
    }, items === null && /*#__PURE__*/React.createElement("p", {
      className: "nc-empty"
    }, "Loading\u2026"), error && /*#__PURE__*/React.createElement("p", {
      className: "nc-empty"
    }, "Notifications could not be loaded. Try again in a moment."), items && !error && items.length === 0 && /*#__PURE__*/React.createElement("p", {
      className: "nc-empty"
    }, tab === "all" ? "Nothing yet. Assignments, mentions, finished jobs and anything that needs you will show here." : "Nothing here."), action.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "nc-day"
    }, "Needs you"), action.map(i => /*#__PURE__*/React.createElement(InboxRow, {
      key: i.id,
      item: i,
      onOpen: this.open
    })), action.length > 0 && rest.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "nc-day"
    }, "Earlier"), rest.map(i => /*#__PURE__*/React.createElement(InboxRow, {
      key: i.id,
      item: i,
      onOpen: this.open
    }))), /*#__PURE__*/React.createElement("div", {
      className: "nc-ft"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nc-link",
      onClick: () => {
        this.props.onClose();
        this.props.history.push("/Notifications/settings");
      }
    }, "Settings"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nc-link strong",
      onClick: () => {
        this.props.onClose();
        this.props.history.push("/Notifications");
      }
    }, "See all notifications"))));
  }
}